import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppearanceThemeModifierDirective } from '@frontend/casino-ui';
import { CasinoTheme, FeatureNames, UIElement } from '@frontend/casino-ui/shared';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { DsPill } from '@frontend/ui/pill';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { PillSubNavConfig } from './pills-sub-navigation.model';

export interface PillDisplayItem {
    isExtendedTopMenuItem?: boolean;
    categoryid: string;
    categoryname: string;
    pathname?: string;
    url?: string;
    signPostingCount?: number;
    isNavigationCategory: boolean;
    classMap?: string;
    index?: number;
    fromExtendedMenuRight?: boolean;
    displayThumbnail?: boolean;
    sitecoreData?: {
        attributes?: {
            icon?: string;
        };
        gameThumbnail?: boolean;
    };
}

export interface PillClickEvent {
    category: PillDisplayItem;
    event: Event;
}

@Component({
    selector: 'cc-pill-item',
    standalone: true,
    imports: [CommonModule, RouterLink, DsPill, AppearanceThemeModifierDirective, IconCustomComponent, DsNotificationBubble],
    templateUrl: './pill-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: flex;
            }
        `,
    ],
})
export class PillItemComponent implements OnInit {
    item = input.required<PillDisplayItem>();
    config = input<PillSubNavConfig>({} as PillSubNavConfig);
    currentTheme = input<CasinoTheme>('bwin');
    featureName = input<FeatureNames>(FeatureNames.NAVBAR);
    isSelected = input<boolean>(false);
    iconName = input<string>('');
    notificationBubbleElement = input<UIElement>('notificationBubble');
    badgeIcon: string;
    onPillClick = output<Event>();

    navItemType: UIElement = 'pill';
    vnIconSize = 16;
    enableVnIconsForPills: boolean;
    categoryStickerName: string;

    computedHref = computed(() => {
        return this.item().url ? this.item().url : this.item().pathname ? [this.item().pathname] : null;
    });

    computedRouterLink = computed(() => {
        return this.item().pathname ? [this.item().pathname] : null;
    });

    computedDynamicClasses = computed(() => {
        if (this.item().sitecoreData?.gameThumbnail) {
            return { thumbnailActive: true };
        }
        return null;
    });

    ngOnInit(): void {
        this.enableVnIconsForPills = !!this.config().enableVnIconsForPills;
        this.categoryStickerName = this.config().categoryStickerName || '';
        this.badgeIcon = this.config().badgeIcon || '';
    }

    handlePillClick(event: Event): void {
        this.onPillClick.emit(event);
    }

    private isDiscoverSticker(categoryid: string): boolean {
        return this.config().discoverFeedLmtkey === categoryid && this.config().displayDiscoverSticker;
    }

    public isBadgeTypeSignPosting(signPostingCount: number): boolean {
        return this.config().isSignPosting && signPostingCount > 0;
    }

    public isBadgeTypeIcon(categoryid: string): boolean {
        return this.isDiscoverSticker(categoryid) && this.config().isBadgeTypeIcon;
    }

    public isBadgeTypeText(categoryid: string): boolean {
        return this.isDiscoverSticker(categoryid) && this.config().isBadgeTypeText;
    }
}
